import React, { useReducer, useState, useCallback } from "react";
import CustomInputField from "../../../components/customInputField";
import { useFormik } from "formik";
import { addSiteInitialValue } from "../../../utils/initialValues";
import { addSitesSchema } from "../../../utils/validationSchema";
import { useDispatch } from "react-redux";
import { addSite, uploadFileToS3, uploadSiteImage } from "../action";
import CustomImgUpload from "../../../components/imgUpload";
import GoogleAutComplete from "../../../components/googleAutocomplete";
import MapComponent from "../../../components/googleAutocomplete/MapComponent";
import { useNavigate } from "react-router-dom";
import { DIVE_TYPES } from "../../../utils/contentTypes";
import Spinner from "../../../components/spinner";
import toast from "react-hot-toast";
import { mediaReducer } from "../reducer";
import CustomModal from "../../../components/customModal";
import axios from "axios";
import {
  extractLatLngCountry,
  extractLocationDetails,
} from "../../../utils/commonFunctions";
import { ERROR_TOAST } from "../../../utils/showToast";
import AsyncAutocomplete from "../../../components/customAutocomplete";
import { Modal, Box, Stack, Button } from "@mui/material";
import { FaMapMarkerAlt } from "react-icons/fa";

/**
 * @function AddSites
 * @description for AddSites
 * @returns JSX for AddSites
 */

export class Media {
  constructor(id, file, status, isDefault, credential, imageUrl, isOverSize) {
    this.id = id;
    this.file = file;
    this.status = status;
    this.isDefault = isDefault;
    this.credential = credential;
    this.imageUrl = imageUrl;
    this.isOverSize = isOverSize;
  }
}

const initialMedia = [];

const AddSites = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setLoading] = React.useState(false);
  const [isRecommend, setIsRecommend] = useState(false);
  const [isBestDestination, setIsBestDest] = useState(false);
  const [latLng, setLatLng] = useState({
    lat: 25.2048,
    lng: 55.2708,
  });
  const [isGetAddress, setIsGetAddress] = useState({
    addressLine2: false,
    lat_lng: false,
    postalCode: false,
    city: false,
    state: false,
    country: false,
  });
  const [selectedCity, setSelectedCity] = useState({});
  const [countryForSearchCity, setCountryForSearchCity] = useState("");
  const [selectedLocation, setSelectedLocation] = useState({
    addressLine: "",
    lat: "",
    lng: "",
    country: "",
  });
  const [isManualAddCity, setIsManualAddCity] = useState(false);
  const [mapModal, setModalMap] = useState(false);
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
  /** for media uploading  **/
  const [isRetryMode, setIsRetryMode] = useState(false);
  const [modal, setModal] = useState({
    show: false,
    unUploadedFiles: 0,
    uploadedFiles: [],
  });
  const [media, dispatchMedia] = useReducer(mediaReducer, initialMedia);

  const modalClose = () => {
    setModal((prev) => ({ ...prev, show: false }));
  };
  const modalConfirmHandler = () => {
    addSiteHandler(modal.uploadedFiles);
    setModal(false);
  };

  const mediaActions = {
    handleAddMedia: useCallback(
      (media) => {
        dispatchMedia({ type: "ADD", payload: media });
      },
      [dispatchMedia]
    ),

    handleMediaStatus: useCallback(
      (id, status) => {
        if (status === "pending") {
          dispatchMedia({ type: "UPDATE_STATUS_PENDING", payload: id });
        } else if (status === "failure") {
          dispatchMedia({ type: "UPDATE_STATUS_FAILURE", payload: id });
        } else {
          console.log("Wrong media status");
          return;
        }
      },
      [dispatchMedia]
    ),

    handleMediaUploadedSuccessFull: useCallback(
      (id, imageUrl) => {
        dispatchMedia({
          type: "UPLOADED_SUCCESSFULLY",
          payload: { id, imageUrl },
        });
      },
      [dispatchMedia]
    ),

    handleDeleteMedia: useCallback(
      (id) => {
        dispatchMedia({ type: "DELETE", payload: id });
      },
      [dispatchMedia]
    ),

    handleDefaultMedia: useCallback(
      (id) => {
        dispatchMedia({ type: "DEFAULT_HANDLER", payload: id });
      },
      [dispatchMedia]
    ),
  };

  const LatlngHandler = (val) => setLatLng(val);
  const defaultImageHandler = (index) => {
    if (index === defaultImage) setDefaultImage(0);
    else setDefaultImage(index);
  };

  const addressHandler = (data) => {
    console.log("data in address handler:", data);

    if (!data) return;
    setLatLng({
      lat: data.lat || "",
      lng: data.lng || "",
    });
    setSelectedLocation({
      addressLine: data.addressLine || "",
      lat: data.lat || "",
      lng: data.lng || "",
      country: data.country || "",
    });
  };

  const addressHandlerFromSelectedCity = (city) => {
    if (!city) {
      siteData.setFieldValue("city", "");
      siteData.setFieldValue("state", "");
      siteData.setFieldValue("country", "");
      return;
    } else {
      const { cityName = "", state = "", country = "" } = city;
      siteData.setFieldValue("city", cityName || "");
      siteData.setFieldValue("state", state || "");
      siteData.setFieldValue("country", country || "");
    }
  };

  const fetchCityFromGoogleHandler = (event) => {
    const value = event.target.value;
    axios
      .get(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${value}&key=${process.env.REACT_APP_GOOGLE_MAP_API_KEY}`
      )
      .then((response) => {
        const locationData = extractLocationDetails(response);
        console.log("locationData by postal code :", locationData);
        if (locationData.city) {
          siteData.setFieldValue("city", locationData.city);
        } else {
          ERROR_TOAST("City not found for the given postal code.");
        }
        if (locationData.state) {
          siteData.setFieldValue("state", locationData.state);
        } else {
          siteData.setFieldValue("state", "");
        }
        if (locationData.country) {
          siteData.setFieldValue("country", locationData.country);
        } else {
          siteData.setFieldValue("country", "");
        }
        if (locationData.lat && locationData.lng) {
          siteData.setFieldValue("latitude", locationData.lat);
          siteData.setFieldValue("longitude", locationData.lng);
          setLatLng((prev) => ({
            lat: locationData.lat,
            lng: locationData.lng,
          }));
        } else {
          siteData.setFieldValue("latitude", "");
          siteData.setFieldValue("longitude", "");
          setLatLng(null);
        }
        if (locationData.addressLine) {
          siteData.setFieldValue("addressLine2", locationData.addressLine);
        } else {
          siteData.setFieldValue("addressLine2", "");
        }
      })
      .catch((error) => {
        console.error("Error fetching postal code data:", error);
        ERROR_TOAST("Something went wrong while fetching postal code data.");
      });
  };
  const reccomendedHandler = () => {
    setIsRecommend(!isRecommend);
  };
  const isBestDestHandler = () => {
    setIsBestDest(!isBestDestination);
  };
  function replaceFileNameWithUserId(fileName) {
    const extensionMatch = fileName.match(/\.[^/.]+$/);
    const extension = extensionMatch ? extensionMatch[0] : "";
    const generateUniqueId = () => Date.now() + Math.floor(Math.random());
    return `${generateUniqueId()}${extension}`;
  }

  const mediaUpload = (media) => {
    return new Promise((resolve, reject) => {
      if (media.status === "success") {
        resolve({
          imageUrl: media.imageUrl,
          isDefault: media.isDefault,
        });
        return;
      }

      mediaActions.handleMediaStatus(media.id, "pending");
      const fileName = replaceFileNameWithUserId(media?.file?.name);

      dispatch(
        uploadSiteImage({ folderType: 4, files: [fileName] }, (response) => {
          if (!response.isSuccess) {
            mediaActions.handleMediaStatus(media.id, "failure");
            reject(response);
            return;
          }
          dispatch(
            uploadFileToS3(media.file, response.data[0], (UrlResponse) => {
              if (UrlResponse.isSuccess) {
                // debugger;
                mediaActions.handleMediaUploadedSuccessFull(
                  media.id,
                  UrlResponse.imageUrl
                );
                if (media.isDefault) {
                  resolve({
                    imageUrl: UrlResponse.imageUrl,
                    isDefault: true,
                  });
                } else
                  resolve({
                    imageUrl: UrlResponse.imageUrl,
                    isDefault: false,
                  });
              } else {
                mediaActions.handleMediaStatus(media.id, "failure");
                reject(UrlResponse);
              }
            })
          );
        })
      );
    });
  };

  const retryHandler = useCallback(
    async (media) => {
      try {
        const result = await mediaUpload(media);
        console.log("Retry upload successful:", result);
      } catch (error) {
        console.error("Retry upload failed:", error);
      }
    },
    [mediaUpload] // Dependency: Ensure `mediaUpload` is stable
  );

  const getImageCrediantial = () => {
    const filesName = siteData.values.images.map((file, index) => {
      function replaceFileNameWithUserId(fileName, userId) {
        // Extract the file extension using a regular expression
        const extensionMatch = fileName.match(/\.[^/.]+$/);
        const extension = extensionMatch ? extensionMatch[0] : "";

        // Return the new file name using the user ID and the original extension
        return `${userId}${extension}`;
      }
      return replaceFileNameWithUserId(file.name, index);
    });

    dispatch(
      uploadSiteImage(
        {
          folderType: 4,
          files: filesName,
        },
        (response) => {
          if (!response) {
            setLoading(false);
          }
          // else uploadFileToS3Handler(response);
        }
      )
    );
  };

  const uploadFileToS3Handler = async (fileResponses) => {
    try {
      delete fileResponses.message;
      let fileUrls = Object.values(fileResponses).filter((item) => item.url);
      let uploadedFiles = [];
      let unUploadedFiles = [];
      const uploadPromises = fileUrls.map(
        (res, index) =>
          new Promise((resolve, reject) => {
            dispatch(
              uploadFileToS3(siteData.values.images[index], res, (response) => {
                if (!response.isSuccess) {
                  unUploadedFiles.push[siteData.values.images[index]];
                  reject(response);
                } else {
                  uploadedFiles.push(response.imageUrl);
                  fileUrls[index] = response.imageUrl;
                  resolve(response);
                }
              })
            );
          })
      );
      const results = await Promise.allSettled(uploadPromises);
      const newImages = results.filter((item) => item.status == "fulfilled");
      if (uploadedFiles.length > 0) {
        addSiteHandler(fileUrls);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error in File Upload:", error);
    }
  };
  const addSiteHandler = (media) => {
    let images = [];
    let defaultImage = "";
    if (isRetryMode) {
      for (let i = 0; i < media.length; i++) {
        if (!media[i].status) {
          processMediaUploadsConcurrently(media);
          return;
        }
        if (media[i].isDefault) {
          if (!media[i].imageUrl) {
            toast.error("Default Image must be uploaded");
            setLoading(false);
            return;
          }
          defaultImage = media[i].imageUrl;
        } else {
          if (media[i].imageUrl) images.push(media[i].imageUrl);
        }
      }
    } else {
      for (let i = 0; i < media.length; i++) {
        if (media[i].value.isDefault) {
          defaultImage = media[i].value.imageUrl;
        } else {
          images.push(media[i].value.imageUrl);
        }
      }
    }
    if (images.length < 1 || !defaultImage) {
      toast.error(
        images.length < 1
          ? "Please upload at least one image."
          : "Please select a default image."
      );
      return;
    }
    setLoading(true);
    const siteAddress = { ...siteData.values };
    delete siteAddress.siteName;
    delete siteAddress.description;
    delete siteAddress.images;
    delete siteAddress.maxDepth;
    delete siteAddress.diveType;
    delete siteAddress.defaultImage;

    const dataToSend = {
      siteAddress: {
        ...siteAddress,
        postalCode: String(siteAddress.postalCode),
      },
      isRecommend,
      isBestDestination,
      siteName: siteData.values.siteName,
      description: siteData.values.description,
      siteImages: [...images],
      defaultImage: defaultImage,
      maxDepth: siteData.values.maxDepth,
      diveType: siteData.values.diveType,
    };

    dispatch(
      addSite(dataToSend, (response) => {
        setLoading(false);
        if (response?.isSuccess) {
          navigate("/sites");
        }
      })
    );
  };

  const processMediaUploadsConcurrently = async (media) => {
    if (isRetryMode) setIsRetryMode(false);
    if (media.length < 2) {
      // atleast 2 file must be uploaded
      toast.error("Please upload at least 2 images or videos.");
      return;
    }

    for (let i = 0; i < media.length; i++) {
      // if large file are available then can't upload
      if (media[i].isOverSize) {
        toast.error(
          "Large size files are not allowed please remove them and then try again "
        );
        return;
      }
    }
    const results = await Promise.allSettled(
      media.map((item) => mediaUpload(item))
    );
    const failedUploads = results.filter(
      (result) => result.status === "rejected"
    );
    const successfulUploads = results.filter(
      (result) => result.status === "fulfilled"
    );

    if (failedUploads.length > 0) {
      if (successfulUploads.length >= 2) {
        // if atleast 2 file are uploaded then only show modal
        setIsRetryMode(true);
      } // if atleast 2 file are not uploaded then toast
      setModal({
        show: true,
        unUploadedFiles: failedUploads.length,
        uploadedFiles: successfulUploads,
      });
      // else
      //   toast.error(
      //     "Please upload at least 2 images or videos to proceed,Please Try again!"
      //   );
    } else {
      addSiteHandler(successfulUploads); // ✅ Runs only if all uploads succeed
    }
  };

  const siteData = useFormik({
    initialValues: addSiteInitialValue,
    validationSchema: addSitesSchema,
    onSubmit: () => processMediaUploadsConcurrently([...media]),
  });
  const resetHandler = () => siteData.resetForm();
  const renderModalBody = () => {
    if (isRetryMode)
      return (
        <div className="report--management--modal--body--container">
          <div className="site-data-container">
            <p className="img-guildlines-para">{`${modal.unUploadedFiles} file(s) are not uploaded due to some problem with them either you can save with them or manully reupload them.`}</p>
          </div>
        </div>
      );
    else {
      return (
        <div className="report--management--modal--body--container">
          <div className="site-data-container">
            <p className="img-guildlines-para">{`Only ${modal.uploadedFiles.length} file(s) are uploaded due to some problem with them either you can edit them or reupload all unuploaded files again .`}</p>
          </div>
        </div>
      );
    }
  };

  console.log("form data :", siteData.values);
  console.log("selected city :", selectedCity);
  return (
    <div className="add-sites-wrapper">
      {isLoading && (
        <div className="spinner-container">
          <Spinner />
        </div>
      )}
      <h3 className="w-50 mb-0 text-primary">{"Add Site"}</h3>
      <div className="user-details-main-container">
        <div className="user-details-container-1 ">
          <div>
            <CustomInputField
              label={"Site name"}
              changeHandler={siteData.handleChange}
              name={"siteName"}
              placeholder={"Enter site name"}
              type={"text"}
              value={siteData.values.siteName}
              blurhandler={siteData.handleBlur}
            />
            {siteData.errors.siteName && siteData.touched.siteName && (
              <div className="change-password-error">
                {siteData.errors.siteName}
              </div>
            )}
          </div>
          <div>
            <label htmlFor="description" className="lable-text">
              {"Description"}
            </label>
            <textarea
              id="desc"
              name="description"
              value={siteData.values.description}
              onChange={siteData.handleChange}
              rows="10"
              cols="50"
              className="form-control"
              placeholder="Enter site description"
              onBlur={siteData.handleBlur}
            ></textarea>
            {siteData.errors.description && siteData.touched.description && (
              <div className="change-password-error">
                {siteData.errors.description}
              </div>
            )}
          </div>
        </div>

        <div className="user-details-container-2 ">
          {/* Profile Section */}
          <div className="personal-info-container">
            <h4 className="label-text heading text-underline ">
              {"Address Information"}
            </h4>
            <div>
              <Modal
                open={mapModal}
                onClose={() => setModalMap(false)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  p: 2,
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "background.paper",
                    borderRadius: 2,
                    boxShadow: 24,
                    p: 3,
                    width: "90%",
                    maxWidth: 700,
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                  }}
                >
                  {/* Google Autocomplete */}
                  <GoogleAutComplete addressHandler={addressHandler} />

                  {/* Map */}
                  <Box
                    className="map-wrapper"
                    sx={{
                      height: 400,
                      borderRadius: 2,
                      overflow: "hidden",
                      border: "1px solid #ddd",
                    }}
                  >
                    <MapComponent
                      latLng={latLng}
                      setLatLng={(val) => {
                        setLatLng({ lat: val.lat, lng: val.lng });
                      }}
                      completeInfoOfCurrentLocation={(val) => {
                        console.log("value of address :", val);
                        const addressToSave = extractLatLngCountry(val);
                        console.log("addressToSave:", addressToSave);
                        if (addressToSave.country === null) {
                          ERROR_TOAST(
                            "No Country found for this location, please select another location."
                          );
                        }
                        console.log("addressToSave:", addressToSave);
                        setSelectedLocation({
                          addressLine: addressToSave.addressLine || "",
                          lat: addressToSave.lat || "",
                          lng: addressToSave.lng || "",
                          country: addressToSave.country || "",
                        });
                      }}
                    />
                  </Box>

                  {/* Buttons */}
                  <Stack direction="row" spacing={2} justifyContent="flex-end">
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => setModalMap(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        siteData.resetForm();
                        setSelectedCity(null);
                        siteData.setFieldValue(
                          "addressLine2",
                          selectedLocation.addressLine
                        );
                        siteData.setFieldValue(
                          "latitude",
                          selectedLocation.lat
                        );
                        siteData.setFieldValue(
                          "longitude",
                          selectedLocation.lng
                        );
                        siteData.setFieldValue(
                          "country",
                          selectedLocation.country
                        );
                        setCountryForSearchCity(selectedLocation.country);
                        setModalMap(false);
                      }}
                    >
                      Save Location
                    </Button>
                  </Stack>
                </Box>
              </Modal>
              <div className=" d-flex justify-content-between ">
                <div className="mb-2">
                  <label className="form-label fw-bold d-block">
                    Select Site Coordinates
                  </label>
                  <small className="text-muted d-block mb-2">
                    Choose your location on Google Map
                  </small>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => setModalMap(true)}
                  >
                    <FaMapMarkerAlt className="me-2" />
                    Open Map
                  </button>
                </div>
                {siteData.values.latitude &&
                  siteData.values.longitude &&
                  (() => {
                    const staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${siteData.values.latitude},${siteData.values.longitude}&zoom=14&size=900x200&markers=color:red%7C${siteData.values.latitude},${siteData.values.longitude}&key=${googleMapsApiKey}`;
                    const mapLink = `https://www.google.com/maps/search/?api=1&query=${siteData.values.latitude},${siteData.values.longitude}`;

                    return (
                      <div style={{ width: "60%", height: "130px" }}>
                        <a
                          href={mapLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ overflow: "hidden" }}
                        >
                          <img
                            src={staticMapUrl}
                            alt="Map showing location"
                            // className="map-image"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                            }}
                          />
                        </a>
                        {!countryForSearchCity.length && (
                          <div className="change-password-error">
                            {
                              "No Country found for this location, please select another location."
                            }
                          </div>
                        )}
                      </div>
                    );
                  })()}
              </div>

              <CustomInputField
                changeHandler={siteData.handleChange}
                label={"Address 1"}
                name={"addressLine1"}
                placeholder={"Enter address 1"}
                value={siteData.values.addressLine1}
                type={"text"}
                blurhandler={siteData.handleBlur}
              />
              {siteData.errors.addressLine1 &&
                siteData.touched.addressLine1 && (
                  <div className="change-password-error">
                    {siteData.errors.addressLine1}
                  </div>
                )}
            </div>
            <div>
              <CustomInputField
                // disabledPropery={isGetAddress.addressLine2}
                readyOnly={true}
                changeHandler={siteData.handleChange}
                label={"Address 2"}
                name={"addressLine2"}
                placeholder={"Enter address 2"}
                value={siteData.values.addressLine2}
                type={"text"}
                blurhandler={siteData.handleBlur}
              />
              {siteData.errors.addressLine2 &&
                siteData.touched.addressLine2 && (
                  <div className="change-password-error">
                    {siteData.errors.addressLine2}
                  </div>
                )}
            </div>
            <div className="info-child-container ">
              <div
                className="info-sub-child-container "
                style={{ paddingBottom: "5px" }}
              >
                <div className="add-city-input-field-container">
                  <AsyncAutocomplete
                    disabled={countryForSearchCity ? false : true}
                    onSelect={(value) => {
                      addressHandlerFromSelectedCity(value);
                    }}
                    selected={selectedCity}
                    setSelected={(val) => setSelectedCity(val)}
                    name="city"
                    placeHolder="Search city name"
                    value={siteData.values.city}
                    changeHandler={(val) => {
                      console.log("change called ");
                      siteData.setFieldValue("city", val);
                    }}
                    blurhandler={siteData.handleBlur}
                    label={"City"}
                    url={
                      countryForSearchCity
                        ? `?pageNo=1&limit=10&country=${countryForSearchCity}`
                        : `?pageNo=1&limit=10`
                    }
                  />
                </div>

                {siteData.errors.city && siteData.touched.city && (
                  <div className="change-password-error">
                    {siteData.errors.city}
                  </div>
                )}
              </div>

              <div className="info-sub-child-container">
                <label className="lable-text" htmlFor="diveType">
                  {"Postal Code"}
                </label>
                <select
                  name="postalCode"
                  id="postalCode"
                  value={siteData.values.postalCode}
                  onChange={siteData.handleChange}
                  className="form-select form-select-md"
                  aria-label="Select Postal Code"
                  blurhandler={siteData.handleBlur}
                  disabled={!selectedCity?.pinCodes?.length}
                >
                  <option value="">{"Select Postal Code"}</option>
                  {selectedCity?.pinCodes?.map((code, index) => (
                    <option key={index} value={code}>
                      {code}
                    </option>
                  ))}
                </select>

                {siteData.errors.postalCode && siteData.touched.postalCode && (
                  <div className="change-password-error">
                    {siteData.errors.postalCode}
                  </div>
                )}
              </div>
            </div>
            <div className="info-child-container ">
              <div className="info-sub-child-container">
                <CustomInputField
                  // disabledPropery={isGetAddress.state}
                  readyOnly={true}
                  changeHandler={siteData.handleChange}
                  label={"State"}
                  name={"state"}
                  placeholder={"Enter state"}
                  value={siteData.values.state}
                  type={"text"}
                  blurhandler={siteData.handleBlur}
                />
                {siteData.errors.state && siteData.touched.state && (
                  <div className="change-password-error">
                    {siteData.errors.state}
                  </div>
                )}
              </div>
              <div className="info-sub-child-container">
                <CustomInputField
                  readyOnly={true}
                  // disabledPropery={isGetAddress.country}
                  changeHandler={siteData.handleChange}
                  label={"Country"}
                  name={"country"}
                  placeholder={"Enter country"}
                  value={siteData.values.country}
                  type={"text"}
                  blurhandler={siteData.handleBlur}
                />
                {siteData.errors.country && siteData.touched.country && (
                  <div className="change-password-error">
                    {siteData.errors.country}
                  </div>
                )}
              </div>
            </div>
            <div className="info-child-container ">
              <div className="info-sub-child-container">
                <CustomInputField
                  // disabledPropery={isGetAddress.lat_lng}
                  readyOnly={true}
                  changeHandler={siteData.handleChange}
                  label={"Longitude"}
                  name={"longitude"}
                  placeholder={"Enter Longitude"}
                  value={siteData.values.longitude}
                  type={"number"}
                  blurhandler={siteData.handleBlur}
                />
                {siteData.errors.longitude && siteData.touched.longitude && (
                  <div className="change-password-error">
                    {siteData.errors.longitude}
                  </div>
                )}
              </div>
              <div className="info-sub-child-container">
                <CustomInputField
                  // disabledPropery={isGetAddress.lat_lng}
                  readyOnly={true}
                  changeHandler={siteData.handleChange}
                  label={"Latitude"}
                  name={"latitude"}
                  placeholder={"Enter latitude"}
                  value={siteData.values.latitude}
                  type={"number"}
                  blurhandler={siteData.handleBlur}
                />
                {siteData.errors.latitude && siteData.touched.latitude && (
                  <div className="change-password-error">
                    {siteData.errors.latitude}
                  </div>
                )}
              </div>
            </div>

            {/* dive types and max depth */}
            <div className="info-child-container ">
              <div className="info-sub-child-container">
                <CustomInputField
                  changeHandler={siteData.handleChange}
                  label={"Max Depth (meter)"}
                  name={"maxDepth"}
                  placeholder={"Enter max depth"}
                  value={siteData.values.maxDepth}
                  type={"number"}
                  blurhandler={siteData.handleBlur}
                />
                {siteData.errors.maxDepth && siteData.touched.maxDepth && (
                  <div className="change-password-error">
                    {siteData.errors.maxDepth}
                  </div>
                )}
              </div>
              <div className="info-sub-child-container">
                <label className="lable-text" htmlFor="diveType">
                  {"Dive Types"}
                </label>
                <select
                  name="diveType"
                  id="diveType"
                  value={siteData.values.diveType}
                  onChange={siteData.handleChange}
                  className="form-select form-select-md"
                  aria-label="Select Dive Type"
                  blurhandler={siteData.handleBlur}
                >
                  <option value="">{"Select Dive Type"}</option>
                  {Object.entries(DIVE_TYPES).map(([key, value], index) => (
                    <option key={index} value={value}>
                      {key}
                    </option>
                  ))}
                </select>

                {siteData.errors.diveType && siteData.touched.diveType && (
                  <div className="change-password-error">
                    {siteData.errors.diveType}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <CustomImgUpload
        media={media}
        handleAddMedia={mediaActions.handleAddMedia}
        handleDeleteMedia={mediaActions.handleDeleteMedia}
        handleMediaStatus={mediaActions.handleMediaStatus}
        handleDefaultMedia={mediaActions.handleDefaultMedia}
        retryHandler={retryHandler}
      />
      <CustomModal
        body={renderModalBody}
        confirmHandler={
          isRetryMode
            ? () => addSiteHandler(modal.uploadedFiles)
            : siteData.handleSubmit
        }
        heading={"Image Upload Details"}
        visible={modal.show}
        visibleHandler={modalClose}
        confirmText={isRetryMode ? "Continue" : "Reupload"}
        closeText={isRetryMode ? "Retry" : "Edit"}
      />

      <div className="bottom-btn-container">
        <button
          type="button"
          className=" btn btn-outline-secondary user-details-btns"
          onClick={resetHandler}
        >
          {"Reset"}
        </button>
        <div className="d-flex align-items-center justify-center gap-4 ">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              name="isRecommend"
              value={isBestDestination}
              id="defaultCheck1"
              onChange={isBestDestHandler}
            />
            <label className="form-check-label" htmlFor="defaultCheck1">
              {"Is Best Destination"}
            </label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              name="isRecommend"
              value={isRecommend}
              id="defaultCheck2"
              onChange={reccomendedHandler}
            />
            <label className="form-check-label" htmlFor="defaultCheck2">
              {"Is Recommended"}
            </label>
          </div>

          <button
            type="submit"
            className="btn btn-primary  user-details-btns"
            onClick={
              isRetryMode ? () => addSiteHandler(media) : siteData.handleSubmit
              // siteData.handleSubmit
            }
          >
            {isRetryMode ? "Save with Uploaded media" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddSites;
